<app-menu></app-menu>
<div class="appContentsContainer">
  <form (ngSubmit)="onSave()" class="formGroup container halfForm">
    <div class="pageTitle">
      {{ "advancedFilters.title" | translate }}
    </div>

    <div class="lineGradient"></div>
    <div
      class="row shortRow"
      *appPermsRoles="[
        roles.ADMIN,
        roles.ANALISTA,
        roles.AAVANZA,
        roles.ABASICO,
        roles.REVISOR,
        roles.RHOMOLOG,
        roles.CONCES,
        roles.RREGION,
        roles.TECNICO
      ]"
    >
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label>Certificados</label>
          </div>
        </div>
        <div class="inputContainerDynamic">
          <app-multi-select-dropdown
            class="w-100"
            *ngIf="isLoaded()"
            [list]="catalogList.certificatesList.list"
            [conf]="catalogList.certificatesList.conf"
            [selectedItems]="catalogList.certificatesList.values"
            (sendValue)="sendValue($event, 'CERTIFICADO')"
          ></app-multi-select-dropdown>
        </div>
      </div>
    </div>
    <div
      class="row shortRow"
      *appPermsRoles="[
        roles.ADMIN,
        roles.ANALISTA,
        roles.ABASICO,
        roles.AAVANZA,
        roles.REVISOR,
        roles.RHOMOLOG,
        roles.CONCES,
        roles.RREGION,
        roles.TECNICO
      ]"
    >
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label>Coc</label>
          </div>
        </div>
        <div class="inputContainerDynamic">
          <app-multi-select-dropdown
            class="w-100"
            *ngIf="isLoaded()"
            [list]="catalogList.cocList.list"
            [conf]="catalogList.cocList.conf"
            [selectedItems]="catalogList.cocList.values"
            (sendValue)="sendValue($event, 'COC')"
          ></app-multi-select-dropdown>
        </div>
      </div>
    </div>
    <div
      class="row shortRow"
      *appPermsRoles="[
        roles.ADMIN,
        roles.ANALISTA,
        roles.AAVANZA,
        roles.REVISOR,
        roles.RHOMOLOG,
        roles.CONCES,
        roles.RREGION,
        roles.TECNICO
      ]"
    >
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label>Placa</label>
          </div>
        </div>
        <div class="inputContainerDynamic">
          <app-multi-select-dropdown
            class="w-100"
            *ngIf="isLoaded()"
            [list]="catalogList.placaList.list"
            [conf]="catalogList.placaList.conf"
            [selectedItems]="catalogList.placaList.values"
            (sendValue)="sendValue($event, 'PLACA')"
          ></app-multi-select-dropdown>
        </div>
      </div>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
